import React from "react";

import IUserEventConsumerProps from "../types/IUserEventConsumerProps";

export interface ComposableUserEventHubConfig {
  /** The composed consumers of user events. */
  Consumers: React.FC<IUserEventConsumerProps>[];
}

/** An event feed which passes user events to all registered consumers. */
const ComposableUserEventHub: React.FC<ComposableUserEventHubConfig & IUserEventConsumerProps> = ({
  Consumers,
  userEvent
}) => {
  return (
    <>
      {Consumers.map((Consumer, index) => (
        <Consumer key={index} userEvent={userEvent} />
      ))}
    </>
  );
};

export default ComposableUserEventHub;
